import { render, staticRenderFns } from "./KeyFigures.vue?vue&type=template&id=6353aaac&"
import script from "./KeyFigures.vue?vue&type=script&lang=js&"
export * from "./KeyFigures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports